
import { defineComponent, computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { AuthController } from "@/app/ui/controllers/AuthController";
import Loading from "@/app/ui/components/loading/index.vue";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { SetupPasswordValidation } from "@/domain/entities/Auth";
import { SetupPasswordValidationApiRequest } from "@/data/payload/api/AuthRequest";
import Valid from "./valid.vue";
import ErrorToken from "./error-token.vue";

export default defineComponent({
  name: "SetupPassword",
  components: {
    Valid,
    ErrorToken,
    Loading
  },
  setup() {
    const route = useRoute();
    const router = useRouter();

    // computed properties
    const token = computed(() => String(route.query?.token || ""));
    const email = computed(() => String(route.query?.email || ""));
    const tokenResponse = computed<SetupPasswordValidation>(
      () => AuthController.tokenResponse
    );
    const messageModalData = computed(() => ({
      ...MainAppController.messageEntities,
      open: MainAppController.messageModal
    }));

    // methods
    const validateSetupPasswordLink = async () => {
      await AuthController.validateSetupPasswordLink(
        new SetupPasswordValidationApiRequest({
          token: token.value,
          email: email.value
        })
      );
    };

    const openModalSuccess = computed(() => AuthController.openModalSuccess);

    const toLogin = () => {
      router.push("/login");
    };

    const onClose = () => {
      AuthController.setModalSuccess(false);
      toLogin();
    };

    // loading
    const loadingModal = computed(() => MainAppController.loadingModal);

    // lifecycle
    onMounted(() => {
      if (!email.value || !token.value) {
        toLogin();
        return;
      }

      validateSetupPasswordLink();
    });

    return {
      // computed/state
      token,
      email,
      tokenResponse,
      openModalSuccess,
      loadingModal,
      messageModalData,

      // methods
      validateSetupPasswordLink,
      onClose,
      toLogin
    };
  }
});
